<template>
  <section-wrapper
    background="custom"
    custom-background="linear-gradient(93.83deg, #1a1423 -13.77%, #6320ee 41.93%, #6cddbe 97.62%)"
    padding="default"
  >
    <div class="about-content">
      <section-header title="Боловсролын салбарын олон улсын аялал" align="center" :dark="true" />

      <p class="about-description">
        Туршлага хуримтлуулах, шинэ бүтээгдэхүүнтэй танилцах, хөрөнгө оруулагч
        олох, шинэлэг санаагаа хөгжүүлэх боломжийг боловсролын салбарын
        мэргэжилтнүүдэд олгох зорилгоор бид олон улсын хамгийн нэр хүндтэй арга
        хэмжээ, үзэсгэлэн худалдааг судлан танд танилцуулж байна. Ингэснээр та
        цаг, мөнгөө хэмнээд зогсохгүй шинэ мэдлэг, бүтээлч санаа, эерэг урам
        зоригийг авч, үнэ цэнтэй аяллыг өөртөө бий болгох боломжтой.
      </p>

      <div class="clients-section">
        <h3 class="clients-title">OUR CLIENTS & PARTNERS</h3>

        <div
          class="carousel-section"
          ref="carousel"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="endDrag"
          @mouseleave="endDrag"
          @touchstart="startDrag"
          @touchmove="onDrag"
          @touchend="endDrag"
        >
          <div
            class="logo-track"
            :style="{ transform: `translateX(${translateX}px)` }"
          >
            <!-- Duplicate logos for infinite scroll -->
            <div
              class="logo-item"
              v-for="(logo, index) in [...logos, ...logos, ...logos]"
              :key="index"
            >
              <img :src="logo.img" :alt="logo.alt" class="logo-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section-wrapper>
</template>

<script>
import SectionWrapper from "./SectionWrapper.vue";
import SectionHeader from "./SectionHeader.vue";

export default {
  name: "AboutSection",
  components: {
    SectionWrapper,
    SectionHeader,
  },
  data() {
    return {
      translateX: 0,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      animationFrame: null,
      logos: [
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/Kucoin.webp",
          alt: "Kucoin",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/coinbase.webp",
          alt: "Coinbase",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/PrimeXBT.webp",
          alt: "PrimeXBT",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/PEGA-POOl.webp",
          alt: "PEGA POOL",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/Lbank.webp",
          alt: "Lbank",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/Luckyblock.webp",
          alt: "Lucky Block",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/bingx.webp",
          alt: "BingX",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/Bybit-1.webp",
          alt: "Bybit",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/bibox.webp",
          alt: "Bibox",
        },
        {
          img: "https://www.globalaishow.com/wp-content/uploads/2024/09/nexo.webp",
          alt: "Nexo",
        },
      ],
    };
  },
  mounted() {
    this.startAutoScroll();
  },
  beforeDestroy() {
    this.stopAutoScroll();
  },
  methods: {
    startAutoScroll() {
      const animate = () => {
        if (!this.isDragging) {
          this.translateX -= 0.5; // Speed of auto-scroll

          // Reset position for infinite scroll
          const trackWidth = this.logos.length * 170; // 160px width + 10px gap
          if (Math.abs(this.translateX) >= trackWidth) {
            this.translateX = 0;
          }
        }
        this.animationFrame = requestAnimationFrame(animate);
      };
      this.animationFrame = requestAnimationFrame(animate);
    },
    stopAutoScroll() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      this.scrollLeft = this.translateX;
      if (this.$refs.carousel) {
        this.$refs.carousel.style.cursor = "grabbing";
      }
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();

      const x = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
      const walk = (x - this.startX) * 1.5;
      this.translateX = this.scrollLeft + walk;
    },
    endDrag() {
      this.isDragging = false;
      if (this.$refs.carousel) {
        this.$refs.carousel.style.cursor = "grab";
      }
    },
  },
};
</script>

<style scoped>
.about-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 20px;
}

.about-description {
  font-size: 18px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 80px;
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 400;
}

.about-description strong {
  font-weight: 700;
  color: white;
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.4);
  text-underline-offset: 4px;
}

.clients-section {
  margin-top: 80px;
  padding: 50px 20px;
}

.clients-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 3px;
  margin-bottom: 50px;
  text-transform: uppercase;
}

.carousel-section {
  overflow: hidden;
  cursor: grab;
  user-select: none;
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(99, 32, 238, 0.1) 0%,
    transparent 10%,
    transparent 90%,
    rgba(99, 32, 238, 0.1) 100%
  );
}

.carousel-section:active {
  cursor: grabbing;
}

.logo-track {
  display: flex;
  gap: 10px;
  will-change: transform;
  padding: 0;
}

.logo-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 80px;
  border-radius: 12px;
  padding: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(99, 32, 238, 0.3);
}

.logo-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: all 0.3s ease;
}

.logo-item:hover .logo-image {
  transform: scale(1.1);
}

/* Responsive Design */
@media (max-width: 960px) {
  .about-content {
    padding: 15px;
  }

  .about-description {
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 60px;
  }

  .clients-section {
    margin-top: 60px;
    padding: 40px 15px;
  }

  .clients-title {
    font-size: 13px;
    margin-bottom: 40px;
  }

  .carousel-section {
    padding: 35px 0;
  }

  .logo-track {
    gap: 8px;
  }

  .logo-item {
    width: 140px;
    height: 70px;
    padding: 12px;
  }
}

@media (max-width: 600px) {
  .about-content {
    padding: 10px;
  }

  .about-description {
    font-size: 14px;
    line-height: 1.7;
    margin-bottom: 45px;
  }

  .clients-section {
    margin-top: 45px;
    padding: 30px 8px;
  }

  .clients-title {
    font-size: 11px;
    letter-spacing: 1.5px;
    margin-bottom: 30px;
  }

  .carousel-section {
    padding: 25px 0;
  }

  .logo-track {
    gap: 6px;
  }

  .logo-item {
    width: 110px;
    height: 55px;
    padding: 8px;
  }
}

@media (max-width: 400px) {
  .about-description {
    font-size: 13px;
  }

  .logo-item {
    width: 100px;
    height: 50px;
  }
}
</style>
